var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgQrCode = function SvgQrCode(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 2.917V1.75M9.333 7h-1.75A.584.584 0 0 1 7 6.417V5.25M2.333 7H1.75M8.75 10.5H7.583a.584.584 0 0 0-.583.583v1.167M7 8.75h3.5M12.25 8.75v2.917a.583.583 0 0 1-.583.583H8.75M4.083 7H5.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1F2937",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.667 5.25H2.333a.584.584 0 0 1-.583-.583V2.333c0-.322.261-.583.583-.583h2.334c.322 0 .583.261.583.583v2.334a.584.584 0 0 1-.583.583ZM4.667 12.25H2.333a.584.584 0 0 1-.583-.583V9.333c0-.322.261-.583.583-.583h2.334c.322 0 .583.261.583.583v2.334a.584.584 0 0 1-.583.583ZM11.667 5.25H9.333a.584.584 0 0 1-.583-.583V2.333c0-.322.261-.583.583-.583h2.334c.322 0 .583.261.583.583v2.334a.584.584 0 0 1-.583.583Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    d: "M3.189 3.186a.44.44 0 1 1 .622.623.44.44 0 0 1-.622-.623Zm.618.618a.435.435 0 1 0-.614-.614.435.435 0 0 0 .614.614Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M3.935 3.497a.435.435 0 1 1-.87 0 .435.435 0 0 1 .87 0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    d: "M10.186 3.188a.44.44 0 1 1 .622.623.44.44 0 0 1-.622-.623Zm.618.62a.435.435 0 1 0-.614-.615.435.435 0 0 0 .614.614Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M10.932 3.5a.435.435 0 1 1-.87 0 .435.435 0 0 1 .87 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    d: "M10.769 6.688a.44.44 0 1 1 .623.623.44.44 0 0 1-.623-.623Zm.619.62a.435.435 0 1 0-.615-.615.435.435 0 0 0 .615.614Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M11.515 7a.435.435 0 1 1-.869 0 .435.435 0 0 1 .869 0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    d: "M10.186 10.188a.44.44 0 1 1 .622.624.44.44 0 0 1-.622-.624Zm.618.62a.434.434 0 1 0-.613-.615.434.434 0 0 0 .613.614Z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M10.932 10.5a.434.434 0 1 1-.869 0 .434.434 0 0 1 .869 0Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    fillRule: "evenodd",
    d: "M3.191 10.188a.44.44 0 1 1 .623.623.44.44 0 0 1-.623-.623Zm.62.62a.435.435 0 1 0-.616-.616.435.435 0 0 0 .615.615Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1F2937",
    d: "M3.938 10.5a.435.435 0 1 1-.87 0 .435.435 0 0 1 .87 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQrCode);
export default ForwardRef;